import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr"
import { documentSigningApiUrl } from "../../config/microservicesUrls"
import { docSigningApiTemplateGet } from "./documentsApi"
import { LogError } from "../../helpers/logger"

const api_url = documentSigningApiUrl()

const setupSignalRConnection = () => {
  // Setup Connection
  const connection = new HubConnectionBuilder()
    .withUrl(`${api_url}/hubs/hellosign`)
    .configureLogging(LogLevel.Warning)
    .build()
  connection?.onclose(async () => {
    connection?.start().catch((error) => {
      console.warn(error)
    })
  })

  return connection
}

const getTemplateDetails = async (jwt, templateId) => {
  try {
    return await docSigningApiTemplateGet(jwt, templateId)
  } catch (error) {
    console.error(error)
  }
}

const validateTemplateGroup = (template, groupId) => {
  try {
    // Check if this template belongs to the active user's group
    if (template) {
      // Extract GID
      const tGID = template.template.metadata?.GroupId?.split("||")[0]

      // Compare GID
      if (tGID === groupId) {
        return true
      }
    }
  } catch (error) {
    console.warn(error)
  }
  return false
}

const handleHelloSignEvent = (
  data,
  tokenDocumentSign,
  setNotificationError,
  setNotificationInformation,
  groupId,
  onRefreshCallBack
) => {
  const successEvents = [20] //20: "template_created"
  const failEvents = [21] //21: "template_error"

  if (successEvents.includes(data.event.eventType)) {
    getTemplateDetails(tokenDocumentSign, data.template?.templateId).then(
      (template) => {
        if (validateTemplateGroup(template, groupId)) {
          setNotificationInformation(
            "A template was created/updated. Refresh to update your list"
          )

          if(!!onRefreshCallBack){
            onRefreshCallBack()
          }
    
        } else if (failEvents.includes(data.event_type)) {
          if ((validateTemplateGroup(template), groupId)) {
            setNotificationError(
              "There was an error creating/updating a template. Please try again if this was your template. Refresh to update your list."
            )
            
          if(!!onRefreshCallBack){
            onRefreshCallBack()
          }
          }
        }
      }
    ).catch((error) => {
      LogError("Error processing HelloSign event", error) 
    })
  }
}

export { setupSignalRConnection, handleHelloSignEvent }
